module.exports = __webpack_public_path__ + "img/toast-success.da721457.svg";